<template>
  <tr>
    <td :colspan="colspan" >
      <div class="empty-table-row">
        <slot></slot>
      </div>
    </td>
  </tr>
</template>
<script>
export default {
  name: 'EmptyTableRow',
  props: {
    colspan: {
      type:Number,
      required: true
    }
  }
}
</script>
<style scoped>
tr {
  background-color: white;
}
.empty-table-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(120, 120, 120);
}
</style>